import PropTypes from '../../_utils/props-types';
export const AppsManagementProps = () => ({
    prefixCls: PropTypes.string,
    data: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'GET',
                params: {},
                callback: null
            };
        }
    },
    createApp: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'POST',
                params: {},
                callback: null
            };
        }
    },
    updateApp: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'POST',
                params: {},
                callback: null
            };
        }
    },
    deleteApp: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'DELETE',
                params: {},
                callback: null
            };
        }
    },
    uploadImage: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'POST',
                params: {},
                callback: null
            };
        }
    },
    deleteImage: {
        type: Object,
        default: () => {
            return {
                url: null,
                method: 'DELETE',
                params: {},
                callback: null
            };
        }
    },
    paginationLocale: PropTypes.any
});
